// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/status.$id.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/status.$id.tsx");
  import.meta.hot.lastModified = "1735909117567.1995";
}
// REMIX HMR END

import { AwaitErrorElement, SkeletonLoader } from '#app/components/ui';
import { fetchStatusEntriesUseCase } from '#app/modules/notion/use-cases/status';
import { invariantResponse, metaTags } from '#app/utils/misc';
import { Alert, Container, Title, TypographyStylesProvider } from '@mantine/core';
import { Await, useLoaderData } from '@remix-run/react';
import { Suspense } from 'react';
import { Incident } from './status.index';
import { TbAlertCircle } from 'react-icons/tb';
export const meta = () => {
  return metaTags({
    title: 'Status'
  });
};
export const headers = () => ({
  'Cache-Control': 'max-age=30'
});
export async function loader({
  params,
  context
}) {
  invariantResponse(params.id, 'ID is required');
  const entries = await fetchStatusEntriesUseCase();
  return {
    entry: entries.find(e => e.id === params.id)
  };
}
export default function Status() {
  _s();
  const loaderData = useLoaderData();
  return <Container size="md">
			<Suspense fallback={<SkeletonLoader mt="xl" />}>
				<Await resolve={loaderData.entry} errorElement={<AwaitErrorElement />}>
					{entry => entry ? <Item entry={entry}></Item> : <Alert color="red" title="Error" icon={<TbAlertCircle />}>
								Entry not found
							</Alert>}
				</Await>
			</Suspense>
		</Container>;
}
_s(Status, "ceKF1Gd7W4lGV+M78eBsU+KQIkw=", false, function () {
  return [useLoaderData];
});
_c = Status;
function Item(props) {
  const status = props.entry.status == 'open' || props.entry.status == 'working' ? 'open' : 'closed';
  return <>
			<Title order={1} mb="md">
				Statusmeldung
			</Title>

			<Incident id={props.entry.id} severity={props.entry.severity} title={props.entry.title} startDate={props.entry.startDate} endDate={props.entry.endDate} status={status} disableButton />

			{props.entry.description && <TypographyStylesProvider mt="lg">
					<div dangerouslySetInnerHTML={{
        __html: props.entry.description
      }} />
				</TypographyStylesProvider>}
		</>;
}
_c2 = Item;
var _c, _c2;
$RefreshReg$(_c, "Status");
$RefreshReg$(_c2, "Item");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;